import React from "react"
import { HStack, Tag } from "@chakra-ui/react"
import capitalize from "lodash/capitalize"
import merge from "lodash/merge"

const colors = {
  Blog: "#129459",
  News: "#3399FF",
  Default: "#3399FF",
}

const getBg = tag => {
  const color = colors[tag]
  return color ? color : colors.Default
}

const defaultStyles = {
  root: {
    mt: "0px",
  },
  tag: {
    borderRadius: "24px",
    ppadding: "8px 16px",
    color: "white",
    width: "auto",
    height: "32px",
    fontSize: "14px",
  },
}

const Tags = ({ tags, styles }) => {
  const _styles = merge({}, defaultStyles, styles)
  return (
    <HStack spacing={4} sx={_styles.root}>
      {tags?.map(tag => (
        <Tag key={tag} sx={_styles.tag} bg={getBg(tag)}>
          {capitalize(tag)}
        </Tag>
      ))}
    </HStack>
  )
}

Tags.defaultProps = {
  styles: {},
}

export default Tags
